import { apiSlice } from '../../api/apiSlice';
import {
    DISPUTE_ALL_RESOLVE,
    DISPUTE_CREATE,
    DISPUTE_GET,
    DISPUTE_REASONS,
    DISPUTE_RESOLVE,
    DISPUTE_STATUS,
    DISPUTE_UPDATE,
    DISPUTE_UPDATE_ALL_DISPUTES,
    RESOLUTION_REASONS,
} from '../../constants';

export const DisputeSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getDisputeStatus: builder.query({
            query: () => {
                return {
                    url: DISPUTE_STATUS,
                };
            },
        }),
        getResolutionReasons: builder.query({
            query: (arg: any) => {
                const { typeId } = arg;
                return {
                    url: RESOLUTION_REASONS,
                    params: { typeId },
                };
            },
        }),
        getDisputeReasons: builder.query({
            query: (arg: any) => {
                const { typeId } = arg;
                return {
                    url: DISPUTE_REASONS,
                    params: { typeId },
                };
            },
        }),
        createDispute: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_CREATE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
        updateDispute: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_UPDATE,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
        resolveDispute: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_RESOLVE,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
        getDisputes: builder.query({
            query: (arg: any) => {
                const queryParams = 'disputeIds=' + arg.disputeIds.join('&disputeIds=');
                return {
                    url: DISPUTE_GET + `?${queryParams}`,
                };
            },
            // keepUnusedDataFor: 0,
        }),
        resolveAllDisputes: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_ALL_RESOLVE,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
        updateAllDisputes: builder.mutation({
            query: (arg: any) => ({
                url: DISPUTE_UPDATE_ALL_DISPUTES,
                method: 'PUT',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Disputes'],
        }),
    }),
});

export const {
    useGetDisputeStatusQuery,
    useGetResolutionReasonsQuery,
    useGetDisputeReasonsQuery,
    useCreateDisputeMutation,
    useUpdateDisputeMutation,
    useResolveDisputeMutation,
    useResolveAllDisputesMutation,
    useGetDisputesQuery,
    useUpdateAllDisputesMutation,
} = DisputeSlice;
